// src/services/groupService.js
import axios from 'axios';
import API_BASE_URL from '../config';

// ✅ Create a new group
export async function createGroup(name) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.post(`${API_BASE_URL}/api/group/create/`, { name }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("✅ Group created:", res.data);
  return res.data;
}

// ✅ Fetch all groups where user is a member
export async function fetchUserGroups() {
  const token = localStorage.getItem("accessToken");
  const res = await axios.get(`${API_BASE_URL}/api/group/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("📦 Fetched user groups:", res.data.groups);
  return res.data.groups;
}

// ✅ Add task to a group
export async function addGroupTask(group_id, text, shared_with = []) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.post(`${API_BASE_URL}/api/group/task/`, {
    group_id,
    text,
    shared_with
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("📝 Group task added:", res.data);
  return res.data;
}

// ✅ Get all tasks from a group
export async function fetchGroupTasks(group_id) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.get(`${API_BASE_URL}/api/group/${group_id}/tasks/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("📂 Tasks for group:", group_id, res.data);
  return res.data;
}

// ✅ Accept a shared task
export async function acceptGroupTask(task_id) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.post(`${API_BASE_URL}/api/group/accept/`, {
    task_id
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("🎯 Accepted shared task:", task_id);
  return res.data;
}

// ✅ List accepted group tasks
export async function listAcceptedTasks() {
  const token = localStorage.getItem("accessToken");
  const res = await axios.get(`${API_BASE_URL}/api/group/accepted/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("📥 Accepted shared tasks:", res.data);
  return res.data;
}

// ✅ Update group task
export async function updateGroupTask(task_id, new_text) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.post(`${API_BASE_URL}/api/group/task/${task_id}/edit/`, {
    text: new_text
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("✏️ Updated group task:", res.data);
  return res.data;
}

// ✅ Delete group task
// ✅ Delete group task
export async function deleteGroupTask(task_id) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.delete(`${API_BASE_URL}/api/group/task/${task_id}/delete/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("🗑️ Deleted group task:", res.data);
  return res.data;
}

// ✅ List group members
export async function listGroupMembers(group_id) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.get(`${API_BASE_URL}/api/group/${group_id}/members/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("👥 Group members:", res.data.members);
  return res.data;
}

// ✅ Invite member to group
export async function inviteMemberToGroup(group_id, username) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.post(`${API_BASE_URL}/api/group/invite/`, {
    group_id,
    username
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("📨 Invited user:", res.data);
  return res.data;
}

// ✅ Remove member from group
export async function removeMemberFromGroup(group_id, user_id) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.post(`${API_BASE_URL}/api/group/remove/`, {
    group_id,
    user_id
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  console.log("🚫 Removed user:", res.data);
  return res.data;
}

// ✏️ Rename a group (admin only)
export async function renameGroup(group_id, name) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.put(`${API_BASE_URL}/api/group/${group_id}/edit/`, { name }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

// 🗑️ Delete a group (admin only)
export async function deleteGroup(group_id) {
  const token = localStorage.getItem("accessToken");
  const res = await axios.delete(`${API_BASE_URL}/api/group/${group_id}/delete/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}
